import styled from '@emotion/styled';
import { Indicator, Model } from '@arra/core';

import { IconContainer, scopeIcons } from './ResultsSimple';

import { useTranslation } from 'react-i18next';
import { TitleScoreContainer } from './ResultsSimple';
import keyify from '../project/parameters/keyify';
import { co2Units, humanizeValue } from '../actions/page/ActionCard';

const IndicatorComponentContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 16px;
  row-gap: 4px;
`;

const IndicatorWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-grow: 1;
`;

interface IndicatorProps {
  result: Indicator;
  modelName?: string;
}

const IndicatorComponent = ({ result, modelName }: IndicatorProps) => {
  const { t } = useTranslation(['project', 'model']);
  const icon = scopeIcons[result.code!] ?? null;
  const translationPrefix = `model:${keyify(modelName)}.result.${
    result.code?.toLowerCase()
  }`;
  const impactScope =
    result.unit && co2Units.has(result.unit) ? 'co2' : result.code;
  const humanizedImpact = result?.unit && result?.number && impactScope
    ? humanizeValue(result.unit, Number(result.number), impactScope)
    : null;
  return (
    <IndicatorComponentContainer>
      {icon && <IconContainer>{icon}</IconContainer>}
      <TitleScoreContainer>
        <p>{modelName ? t(`${translationPrefix}.title`) : result.title}</p>
      </TitleScoreContainer>
      <IndicatorWrapper>
        <p className="h5r">
          <b>{humanizedImpact?.value || 0}</b>{' '}
          <span className="hzr">{humanizedImpact?.unit || ''}</span>
        </p>
      </IndicatorWrapper>
    </IndicatorComponentContainer>
  );
};

export default IndicatorComponent;
